import { faUser } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, SxProps, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MultiElementColumnHeaderParams } from '../../modules/tools/models/tools.types';

const ColumnHeader = (props: MultiElementColumnHeaderParams) => {
  const { t } = useTranslation();
  let title = '';
  let styles: SxProps<Theme> = { paddingX: '8px' };

  switch (props.title) {
    case 'email':
      title = t('app.emailAddress');
      break;
    case 'name':
      title = t('app.name');
      styles = {
        paddingLeft: '60px',
        paddingRight: '8px',
      };
      break;
    case 'birthday':
      title = t('app.birthday');
      styles = {
        ...styles,
        minWidth: 300,
        justifyContent: 'start',
        backgroundColor: '#EEF0F2',
        '& .MuiDataGrid-columnHeader': {
          backgroundColor: '#006600',
        },
      };
      break;
    case 'language':
      title = t('app.language');
      styles = {
        ...styles,
        minWidth: 300,
        justifyContent: 'start',
        backgroundColor: '#EEF0F2',
      };
      break;
    case 'actions':
      title = t('app.actions.title');
      styles = {
        minWidth: 120,
        justifyContent: 'center',
        backgroundColor: 'primary.main',
        color: 'background.paper',
      };
      break;
  }

  return (
    <Box className="flex w-full truncate font-semibold" sx={styles}>
      {title}
    </Box>
  );
};

export default ColumnHeader;
